/**
 * How a review package's outstanding tracked changes should be resolved into the workspace file
 * when the package is merged.
 */
export enum ReviewApplyOption {
  /** Merge the review's tracked changes into the workspace doc as still-pending tracked changes, for the workspace author to resolve individually later. */
  Transfer,
  /** Flatten (auto-accept) the review's tracked changes, then merge the resulting content into the workspace doc. */
  Accept,
  /** Discard the review's tracked changes. The workspace file is left untouched. */
  Reject
}
